<div class="uploader-card">
  <div class="icon-wrapper">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  </div>
  <h3>Import Data</h3>
  <p class="subtitle">Upload your fixed-format Excel report (.xlsx)</p>
  
  <input type="file" id="fileInput" #fileInput (click)="onInputClick()" (change)="onFileChange($event)" accept=".xlsx, .xls" [disabled]="isUploading" class="hidden-input" />
  <label for="fileInput" class="upload-btn" [class.disabled]="isUploading">
    {{ isUploading ? 'Uploading...' : 'Select File' }}
  </label>
  
  <div *ngIf="isUploading" class="progress-container">
    <div class="progress-track">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
    <span class="progress-text">{{ progress }}%</span>
  </div>
  
  <div *ngIf="uploadMessage" class="status-message" [class.error]="uploadMessage.includes('Error')" [class.success]="!uploadMessage.includes('Error') && !isUploading">
    {{ uploadMessage }}
  </div>
</div>